import { render, staticRenderFns } from "./ResidentManage.vue?vue&type=template&id=1f3e8027&scoped=true&"
import script from "./ResidentManage.vue?vue&type=script&lang=js&"
export * from "./ResidentManage.vue?vue&type=script&lang=js&"
import style0 from "./ResidentManage.vue?vue&type=style&index=0&id=1f3e8027&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3e8027",
  null
  
)

export default component.exports